"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var IconButton = (0, _theming.styled)("button", process.env.NODE_ENV === "production" ? {
  target: "e6kvtg60"
} : {
  target: "e6kvtg60",
  label: "IconButton"
})("color:", function (props) {
  return props.inverse ? _styles.color.lightest : '#7a858e';
}, ";border-radius:", _styles.spacing.borderRadius.small, "px;border:0;outline:0;background-color:transparent;transition:background-color 150ms ease-out,color 150ms ease-out;width:28px;height:28px;padding:5px;svg{width:14px;height:14px;display:block;margin:0 auto;}", function (props) {
  return props.monochrome ? /*#__PURE__*/(0, _theming.css)("&:hover,&:focus{background-color:rgba(255, 255, 255, 0.14);color:", _styles.color.lightest, ";}&:active{background-color:rgba(255, 255, 255, 0.07);color:", _styles.color.lightest, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:IconButton;")) : /*#__PURE__*/(0, _theming.css)("&:hover,&:focus{background-color:rgba(30, 167, 253, 0.14);color:", _styles.color.secondary, ";}&:active{background-color:rgba(30, 167, 253, 0.07);color:", _styles.color.secondary, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:IconButton;"));
}, ";");
exports.IconButton = IconButton;